import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import PageHeadingSection from '../../../../common/pageheading/PageHeadingSection';
import Breadcrumbs from '../../../../common/BreadCrum/BreadCrum';
import SectionTab from '../../../../common/sectiontab/SectionTab';
import UnitList from './UnitList';
import UnitNumberMaster from './UnitNumberMaster';

const UnitManagementMain = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('list');

    const tabs = [
        {
            key: 'list',
            label: 'Unit List',
            component: () => (
                <div className="flex-1 flex flex-col [&>div]:border-0 [&>div]:px-0 [&>div]:pt-0">
                    <UnitList />
                </div>
            )
        },
        {
            key: 'master',
            label: 'Unit Master',
            component: () => (
                <div className="flex-1 flex flex-col [&>div]:border-0 [&>div]:px-0 [&>div]:pt-0">
                    <UnitNumberMaster />
                </div>
            )
        }
    ];

    const getPrimaryBtnProps = () => {
        if (activeTab === 'list') {
            return {
                primaryBtnText: "Create Unit",
                primaryBtnIcon: faPlus,
                PrimaryOnClick: () => navigate('/zentres/site-management/unit/form')
            };
        }
        if (activeTab === 'master') {
            return {
                primaryBtnText: "Add New Unit Numbers",
                primaryBtnIcon: faPlus,
                PrimaryOnClick: () => navigate('/zentres/site-management/unit-number/form')
            };
        }
        return {};
    };

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto">
            <Breadcrumbs />
            <PageHeadingSection
                mainHeading="Unit Management"
                subHeading="Manage tenant unit mapping and register physical unit numbers."
                Navbar={true}
                {...getPrimaryBtnProps()}
            />
            
            <SectionTab 
                tabs={tabs} 
                defaultTab="list" 
                activeTab={activeTab}
                onTabChange={setActiveTab}
            />
        </div>
    );
};

export default UnitManagementMain;
